import React, { useState, useEffect, useContext, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { withRouter } from "../../providers/withRouter";
import { UsuarioContext } from '../../providers/userContext';
import { getStandByAlertSupps, validateStandBySuppAlert, validateWelcomeSuppAlert } from "../../services";
import { daysDiff, formatoFechasEs } from '../../functions/funciones';
import { FaCheck } from "react-icons/fa";
import { Link, useNavigate } from 'react-router-dom';
import { useRecogerURLParamsFiltros, construirURLParamsFiltros } from '../../functions/parametrosURL/funcionesParamsURL';
import { Box, Button } from "@mui/material";
import FiltrosAlertasProv from '../filtros/filtrosAlertasProv';
import DataTable from '../Tables/DataTable';
import { toast } from 'react-toastify';
import Swal from "sweetalert2";



const StandByAlertSupps = ({ valorTab }) => {
    const user = useContext(UsuarioContext);
    const { t } = useTranslation('common');
    const [proveedores, setProveedores] = useState([]);
    const [proveedor, setProveedor] = useState({});
    const { filtrosIniciales, filtroOrder } = useRecogerURLParamsFiltros();
    const [busqueda, setBusqueda] = useState(filtrosIniciales);
    const [loading, setLoading] = useState(true);
    const [recargar, setRecargar] = useState(false);
    const [busquedaActiva, setBusquedaActiva] = useState(false);
    const [validating, setValidating] = useState(false);
    const [clearFilterActivo, setClearFilterActivo] = useState(false);
    const [data, setData] = useState({
    meta: {},
    rows: [],
    });
    
    const [primeraCarga, setPrimeraCarga] = useState(true);
    
    const navigate = useNavigate();
    const refControladorAborto = useRef(null);
    
    const clearFilters = () => {
        if (user.rol === "CONSUL" && primeraCarga) {
            setBusqueda({
            ...busqueda,
            consul_id: user.id
            });
        }
        else {
            setBusqueda({});
        }
        setClearFilterActivo(true);
    
    }
    
    const fetchData = async ({ offset, limit, filtros = busqueda, order, orderBy } = {}) => {
    
        orderBy = orderBy || filtroOrder.ordenadoPor || 'ultimaReclamacion';
        order = order || filtroOrder.orden || 'ASC';
    
    
        if (primeraCarga) {
            if (filtros.consul_id === undefined && user.rol === 'CONSUL') {
            filtros.consul_id = user.id
            } else if (filtros.consul_id === 0) {
            delete filtros.consul_id
            }
            setPrimeraCarga(false);
        }
    
        construirURLParamsFiltros(navigate, offset || 1, limit || 50, filtros, order, orderBy, valorTab);
    
        if (refControladorAborto.current) {
            refControladorAborto.current.abort();
        }
        const nuevoControladorAborto = new AbortController();
        refControladorAborto.current = nuevoControladorAborto;
    
        const payload = {
            filtros,
            params: { page: offset, limit, order, orderBy },
            signal: nuevoControladorAborto.signal,
        };
        try {
            setLoading(true);
            const response1 = await getStandByAlertSupps(payload);
            const { meta, data } = response1;
    
            if (refControladorAborto.current === nuevoControladorAborto) {
            setProveedores(data);
            setData({
                meta,
                rows: formatData(data),
            });
            }
        } catch (error) {
            if (error?.name === 'AbortError' || error?.name === 'CanceledError' || error?.code === 'ERR_CANCELED') {
            if (refControladorAborto.current === nuevoControladorAborto) {
                setLoading(false);
            }
            return;
            }
            console.log(error);
        } finally {
            if (refControladorAborto.current === nuevoControladorAborto) {
            setLoading(false);
            }
        }
    };

    const formatData = (data) => {
        return data.map((row, i) => {
        const consultor = row.consultants?.find(objeto => objeto?.r_consul_servsgroups_aaffs.group_id === 1)
        return {
            key: row.id,
            razonSocial: row.razonSocial || row.propertie?.aaff?.nombreContacto,
            proximaReclamacion: row.proximaReclamacion,
            nif: row.nif,
            parent_id: row.parent_id,
            createdAt: row.createdAt,
            consultorCae: consultor ? `${consultor.nombre} ${consultor.apellidos}` : "",
            validar: row.id
        }

        })
    };
    const proveedoresRows = [
        {
          id: "razonSocial",
          numeric: false,
          disablePadding: false,
          label: t('suppliers.columns.supplier'),
          overrideFunc: (data, row) => <Link to={"/proveedores/" + row.nif}>{data}</Link>
        },
        {
            id: "nif",
            numeric: false,
            disablePadding: false,
            label: t('suppliers.columns.nif'),
        },
        {
            id: "proximaReclamacion",
            numeric: false,
            disablePadding: false,
            label: t('suppliers.columns.nextReclamation'),
    
            overrideFunc: (data, row) => <span style={{ color: daysDiff(new Date(data), new Date()) > 30 ? 'red' : 'black' }}>{formatoFechasEs(data)}</span>
        },
        {
            id: "validar",
            numeric: false,
            disablePadding: false,
            noObjeto: true,
            label: t('suppliers.columns.performed'),
            overrideFunc: (data, row) => (
            <>
                <Button style={{ background: validating ? '#7bc977' : 'green', color: 'white', minWidth: '5px' }} onClick={() => handleCheck(data)} disabled={validating}><FaCheck /></Button>
            </>
            )
        },
    ]

    const handleCallback = () => {
        setRecargar(!recargar);
    };

    const handleCheck = async (id) => {
        //fechaminima mañana
        const manana = new Date();
        manana.setDate(manana.getDate() + 1);
        //fecha máxima mas 4 meses 
        const maxFecha = new Date();
        maxFecha.setMonth(maxFecha.getMonth() + 4);

        const minStr = manana.toISOString().split('T')[0];
        const maxStr = maxFecha.toISOString().split('T')[0];

        const result = await Swal.fire({
            title: t('suppliers.messages.validateAlertQuestion'),
            icon: "question",
            input: "date",
            inputLabel: t('suppliers.columns.nextReclamation'),
            inputAttributes: {
                min: minStr,
                max: maxStr
            },
            showCancelButton: true,
            confirmButtonColor: "green",
            cancelButtonColor: "#888",
            cancelButtonText: t('common:actions.cancel'),
            confirmButtonText: t('common:actions.confirm'),
            inputValidator: (value) => {
                if (!value) return t('suppliers.messages.selectDate');
                if (value < minStr || value > maxStr) return t('technicians.messages.incorrectDates');
            }
        });

        if (!result.isConfirmed) return;

        validarSupp(id, result.value).then((resultado) => {
        handleCallback(resultado)
        })
    }

    const validarSupp = async (id, proximaReclamacion) => {
        // Validar documentos en bloque
        return new Promise(async (resolve, reject) => {
            try {
            const toastInfo = toast.info(t('suppliers.messages.validating'), { autoClose: false });
            let proveedor = proveedores.find(p => p.id === id)
            validateStandBySuppAlert(proveedor.id, proximaReclamacion).then(() => {
                toast.update(toastInfo, {
                render: t('suppliers.messages.alertValidated'),
                type: toast.TYPE.SUCCESS,
                autoClose: true,
                });
                resolve(true);
            }).catch((error) => {
                console.log(error)
                toast.update(toastInfo, {
                render: t('suppliers.messages.alertValidationError'),
                type: toast.TYPE.ERROR,
                autoClose: true,
                });
                reject(error)
            })
            setProveedor(proveedor)
            } catch (error) {
            console.log(error)
            toast.error(t('suppliers.messages.errorOccurred'));
            reject(error)
            }
        })
    }

    const filtrarDatos = (filtros) => {
        setBusqueda(filtros);
        setBusquedaActiva(true);
    }

    useEffect(() => {
        return () => {
            if (refControladorAborto.current) {
            refControladorAborto.current.abort();
            }
        };
    }, []);

    return ( 
        <>
            <div className="pageContent tableContainer">

                <FiltrosAlertasProv onFilter={filtrarDatos} clearFilter={clearFilters} filtrosIniciales={busqueda} />
                <div className="tableWrapper">
                    <Box className="pageContent">
                        <Box sx={{ mb: 10 }}>
                        
                            <DataTable
                            data={data.rows}
                            isLoading={loading}
                            headers={proveedoresRows}
                            fetcher={fetchData}
                            currentPage={data.current_page}
                            meta={data.meta}
                            totalItems={data.total}
                            totalPages={data.totalPages}
                            nextPage={data.next_page}
                            filtros={busqueda}
                            busquedaActiva={busquedaActiva}
                            setBusquedaActiva={setBusquedaActiva}
                            clearFilterActivo={clearFilterActivo}
                            mensaje={t('alerts.messages.noPendingTasks')}
                            enumerate={true}
                            recargar={recargar}
                            />
                        
                        </Box>
                    </Box>
                </div>
            </div>
        </>
     );
}
 
export default withRouter(StandByAlertSupps);